/* Local presentation only. Keep native forms, names, URLs and filtering handlers. */
(() => {
  if (document.querySelector('.cabane-sidebar-filters')) return;
  if (!/^\/(collections\/|search)/.test(location.pathname)) return;
  document.documentElement.dataset.localCatalogDesign = 'ligne-claire';
  const order = ['vendor','couleur','taille','price','availability','product_type','tranche_poids'];
  const initialized = new WeakSet();
  function prepare() {
    document.querySelectorAll(".cabane-catalog-search__input").forEach(input => input.placeholder = "Rechercher");
    const rank = details => {
      const index = order.findIndex(key => details.id.includes(key));
      return index < 0 ? order.length : index;
    };
    [...document.querySelectorAll('#FacetFiltersForm details')].sort((a,b) => rank(a) - rank(b)).forEach((details,index) => {
      const position = String(index + 1);
      details.style.setProperty('--local-facet-order', position);
      details.dataset.localFacetOrder = position;
      details.dataset.localFacetEdge = index % 2 ? 'right' : 'left';
      if (initialized.has(details)) return;
      initialized.add(details);
      details.open = false;
      details.querySelector('summary')?.setAttribute('aria-expanded','false');
      details.addEventListener('toggle', () => {
        details.querySelector('summary')?.setAttribute('aria-expanded',String(details.open));
        if (details.open) document.querySelectorAll('#FacetFiltersForm details[open]').forEach(other => {
          if (other !== details) other.open = false;
        });
      });
    });
  }
  prepare();
  const markReady = () => { document.documentElement.dataset.localCatalogReady = 'true'; };
  if (document.readyState === 'loading' || document.readyState === 'interactive') {
    document.addEventListener('DOMContentLoaded', markReady, {once:true});
  } else markReady();
  // The theme's existing toggle handles desktop. Support the same control on
  // mobile, where this local layout also displays the inline filter panel.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cabane-filter-toggle]');
    if (!button || !window.matchMedia('(max-width: 749px)').matches) return;
    const catalog = button.closest('.cabane-catalog');
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!catalog || !panel) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const open = !catalog.classList.contains('is-filters-open');
    catalog.classList.toggle('is-filters-open', open);
    button.setAttribute('aria-expanded', String(open));
    panel.inert = !open;
    panel.setAttribute('aria-hidden', String(!open));
  }, true);
  let pending = false;
  const root = document.querySelector('#MainContent');
  if (root) new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; prepare(); });
  }).observe(root,{childList:true,subtree:true});
  document.addEventListener('keydown', event => {
    if(event.key === 'Escape') document.querySelectorAll('#FacetFiltersForm details[open]').forEach(d => {d.open=false;d.querySelector('summary')?.focus()});
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('#FacetFiltersForm details')) document.querySelectorAll('#FacetFiltersForm details[open]').forEach(d => d.open=false);
  });
})();

